import { LOCATIONS_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const LocationService = {
  getAll: (params: any) => requests.get(`${LOCATIONS_URL}`, params),
  create: (params: any) => requests.post(`${LOCATIONS_URL}`, params),
  getSingle: (id: number) => requests.get(`${LOCATIONS_URL}/${id}`),
  update: (params: any, id: number) =>
    requests.put(`${LOCATIONS_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${LOCATIONS_URL}/${id}`),
};